


export enum BlockTypes {
  USER = "user",
  LOAD_BALANCER = "load_balancer",
  APP_SERVER = "app_server",
  DATABASE = "database",
  DB_READ_REPLICA = "db_read_replica",
  CDN = "cdn",
  AUTO_SCALING_GROUP = "auto_scaling_group",
  CACHE = "cache",
  LAMBDA = "lambda",
  QUEUE = "queue",
}